const TOKEN = "access_token"
const USER = "access_user"
const MENU = "access_menu"
const FCM = "access_fcm"
const RELOAD = "access_reload"
const COMPANY = "access_company"

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const TokenService = {
  getToken() {
    return localStorage.getItem(TOKEN)
  },
  getUser() {
    return localStorage.getItem(USER)
  },
  getMenu() {
    return localStorage.getItem(MENU)
  },
  getFcm() {
    return localStorage.getItem(FCM)
  },
  getReload() {
    return localStorage.getItem(RELOAD)
  },
  getCompany() {
    return localStorage.getItem(COMPANY)
  },

  saveToken(accessToken, accessUser, accessMenu) {
    localStorage.setItem(TOKEN, accessToken)
    localStorage.setItem(USER, accessUser)
    localStorage.setItem(MENU, accessMenu)
  },
  updateMenu(accessMenu) {
    localStorage.setItem(MENU, accessMenu)
  },
  saveFcm(accessFcm) {
    localStorage.setItem(FCM, accessFcm)
  },
  saveReload(accessReload) {
    localStorage.setItem(RELOAD, accessReload)
  },
  saveCompany(accessCompany) {
    localStorage.setItem(COMPANY, accessCompany)
  },
  
  removeToken() {
    localStorage.removeItem(TOKEN)
    localStorage.removeItem(USER)
    localStorage.removeItem(MENU)
    localStorage.removeItem(FCM)
    localStorage.removeItem(RELOAD)
    localStorage.removeItem(COMPANY)
  }
}

export { TokenService }